import MedicalQuestionnaire from '../MedicalQuestionnaire';

export default function MedicalTab({ childId, childName }) {
  return (
    <div className="space-y-6" data-testid="medical-tab">
      <MedicalQuestionnaire 
        childId={childId}
        childName={childName}
        compact={false}
      />
    </div>
  );
}
